import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PredictionFile, User } from '@app/shared/models/CommonModel';
import { Dictation, FIB, HighlightCorrectSummary, HighlightIncorrectWord, MCQ, SelectMissingWords, SummaryListening } from '@app/shared/models/ListeningModel';
import { DropDown, FIBDrag, MCq, Reorder } from '@app/shared/models/ReadingModel';
import { DescribeImage, ReadAloud, RepeatSentence, RetellLecture, ShortQuestion } from '@app/shared/models/SpeakingModel';
import { EssayWriting, SummaryWriting } from '@app/shared/models/WritingModel';
import { environment } from '@environments/environment';
import { map } from 'rxjs/operators';
import { Location } from "@angular/common";
import { FullMockEvaluate } from '@app/shared/models/mock-test-list';
import { Package } from '@app/shared/models/package';
import { GrammarCreate, VocabCreate } from '@app/shared/models/vocab';
import { LiveClass } from '@app/shared/models/live-class';

@Injectable({
    providedIn: 'root'
})
export class SaveService {
    private baseUrl = environment.apiUrl + "/api/v1/";

    constructor(private http: HttpClient, private _loc: Location,) {
    }

    /************************************************
    **************  LISTENING **************
     *************************************************/

    onSaveDictation(obj: Dictation, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `listening/${questionCode}/${questionId}/update` : `listening/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];
            formData.append(key, value);
        }

        if (questionId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }

    onSaveFIB(obj: FIB, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `listening/${questionCode}/${questionId}/update` : `listening/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];
            formData.append(key, value);
        }

        if (questionId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }

    OnSaveMissingWords(obj: SelectMissingWords, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `listening/${questionCode}/${questionId}/update` : `listening/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];
            formData.append(key, value);
        }

        if (questionId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }

    OnSaveSummarySpokenText(obj: SummaryListening, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `listening/${questionCode}/${questionId}/update` : `listening/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];
            formData.append(key, value);
        }

        if (questionId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }

    onSaveHighlightIncorrectWord(obj: HighlightIncorrectWord, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `listening/${questionCode}/${questionId}/update` : `listening/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];
            formData.append(key, value);
        }

        if (questionId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }

    onSaveHighlightCorrectSummary(obj: HighlightCorrectSummary, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `listening/${questionCode}/${questionId}/update` : `listening/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];
            formData.append(key, value);
        }

        if (questionId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }


    onSaveMCQSingle(obj: MCQ, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `listening/${questionCode}/${questionId}/update` : `listening/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];
            formData.append(key, value);
        }

        if (questionId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }

    onSaveMCQMultiple(obj: MCQ, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `listening/${questionCode}/${questionId}/update` : `listening/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];
            formData.append(key, value);
        }

        if (questionId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }


    /************************************************
    *************  WRITING ************************
    *************************************************/

    onSaveStructure(data) {
        return this.http.post<any>(`${this.baseUrl}essays/essay-structure-coherence`, data);
    }

    onSaveComment(data, url) {
        return this.http.post<any>(`${this.baseUrl}writing/${url}/comments`, data);
    }

    onSaveEssay(obj: EssayWriting, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `writing/${questionCode}/${questionId}/update` : `writing/${questionCode}/create`;

        if (questionId)
            return this.http.put<any>(url, obj);
        else
            return this.http.post<any>(url, obj);
    }

    onSaveSummaryWritting(obj: SummaryWriting, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `writing/${questionCode}/${questionId}/update` : `writing/${questionCode}/create`;

        if (questionId)
            return this.http.put<any>(url, obj);
        else
            return this.http.post<any>(url, obj);
    }

    /************************************************
    *************  READING ************************
        *************************************************/

    onSaveReorder(obj: Reorder, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `reading/${questionCode}/${questionId}/update` : `reading/${questionCode}/create`;
        if (questionId)
            return this.http.put<any>(url, obj);
        else
            return this.http.post<any>(url, obj);
    }

    onSaveropDown(obj: DropDown, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `reading/${questionCode}/${questionId}/update` : `reading/${questionCode}/create`;
        if (questionId)
            return this.http.put<any>(url, obj);
        else
            return this.http.post<any>(url, obj);
    }

    onSaveDrag(obj: FIBDrag, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `reading/${questionCode}/${questionId}/update` : `reading/${questionCode}/create`;
        if (questionId)
            return this.http.put<any>(url, obj);
        else
            return this.http.post<any>(url, obj);
    }

    onSaveMCQ(obj: MCq, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `reading/${questionCode}/${questionId}/update` : `reading/${questionCode}/create`;
        if (questionId)
            return this.http.put<any>(url, obj);
        else
            return this.http.post<any>(url, obj);
    }

    /************************************************
    *************  SPEAKING ************************
    *************************************************/

    onSaveDescribeImg(obj: DescribeImage, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `speaking/${questionCode}/${questionId}/update` : `speaking/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];

            formData.append(key, Array.isArray(value) ?
                JSON.stringify(value.map(d => ({ word: d.word })))
                : value);
        }

        if (questionId)
            return this.http.put(url, formData);
        else return this.http.post(url, formData);


    }

    onSaveShortQuestion(obj: ShortQuestion, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `speaking/${questionCode}/${questionId}/update` : `speaking/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];
            formData.append(key, value);
        }

        if (questionId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }

    onSaveReadAloud(obj: ReadAloud, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `speaking/${questionCode}/${questionId}/update` : `speaking/${questionCode}/create`;

        if (questionId)
            return this.http.put(url, obj)
        else
            return this.http.post(url, obj)
    }

    onSaveRellLecture(obj: RetellLecture, questionCode: string, questionId: string) {
        let url = this.baseUrl;
        url += questionId ? `speaking/${questionCode}/${questionId}/update` : `speaking/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];

            formData.append(key, Array.isArray(value) ?
                JSON.stringify(value.map(d => ({ word: d.word })))
                : value);
        }


        if (questionId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }

    onSaveRepeatSentence(obj: RepeatSentence, questionCode: string, questionId) {
        let url = this.baseUrl;
        url += questionId ? `speaking/${questionCode}/${questionId}/update` : `speaking/${questionCode}/create`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];

            formData.append(key, Array.isArray(value) ?
                JSON.stringify(value.map(d => ({ word: d.word })))
                : value);
        }


        if (questionId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }


    onsaveMockTest(data, mockId: string) {
        let url = this.baseUrl;
        url += mockId ? `mock-test/${mockId}` : `mock-test`;

        if (mockId)
            return this.http.put<any>(url, data).pipe(map((obj) => obj || []));
        else
            return this.http.post<any>(url, data).pipe(map((obj) => obj || []));
    }


    onSavePrediction(data: PredictionFile, moduleName: string, predictionId: string) {
        let url = this.baseUrl;
        url += predictionId ? `${moduleName.toLowerCase()}/prediction/${predictionId}` : `${moduleName.toLowerCase()}/prediction`;

        if (predictionId)
            return this.http.put<any>(url, data).pipe(map((obj) => obj || []));
        else
            return this.http.post<any>(url, data).pipe(map((obj) => obj || []));

    }

    onSavePractise(data: PredictionFile, moduleName: string, practiseId: string) {
        let url = this.baseUrl;
        url += practiseId ? `${moduleName.toLowerCase()}/practise/${practiseId}` : `${moduleName.toLowerCase()}/practise`;

        if (practiseId)
            return this.http.put<any>(url, data).pipe(map((obj) => obj || []));
        else
            return this.http.post<any>(url, data).pipe(map((obj) => obj || []));

    }

    onSaveStudyPlan(data: PredictionFile, moduleName: string, studyPlanId: string) {
        let url = this.baseUrl;
        url += studyPlanId ? `${moduleName.toLowerCase()}/study-plan/${studyPlanId}` : `${moduleName.toLowerCase()}/study-plan`;

        if (studyPlanId)
            return this.http.put<any>(url, data).pipe(map((obj) => obj || []));
        else
            return this.http.post<any>(url, data).pipe(map((obj) => obj || []));
    }


    onSaveIndividualMock(data: any, moduleName: string, mockId: string) {
        let url = this.baseUrl;
        url += mockId ? `${moduleName.toLowerCase()}/mock-test/${mockId}` : `${moduleName.toLowerCase()}/mock-test`;

        if (mockId)
            return this.http.put<any>(url, data).pipe(map((obj) => obj || []));
        else
            return this.http.post<any>(url, data).pipe(map((obj) => obj || []));
    }

    onSavePackage(data: Package, id: string, type: string) {
        let url = this.baseUrl;
        url += id ? `ai/store/packages/${id}/${type}` : `ai/store/packages/${type}`;

        if (id)
            return this.http.put<any>(url, data).pipe(map((obj) => obj || []));
        else
            return this.http.post<any>(url, data).pipe(map((obj) => obj || []));
    }

    onSaveYoutubeLink(data: Package, id: string) {
        let url = this.baseUrl;
        url += id ? `dashboard/youtubelink/${id}` : `dashboard/youtubelink`;

        if (id)
            return this.http.put<any>(url, data).pipe(map((obj) => obj || []));
        else
            return this.http.post<any>(url, data).pipe(map((obj) => obj || []));
    }

    onSaveVocabQuestion(data: VocabCreate, code: string, id = null) {
        let url = this.baseUrl;
        url += id ? `vocab/${code}/${id}/update` : `vocab/${code}/create`;

        if (id)
            return this.http.put<any>(url, data).pipe(map((obj) => obj || []));
        else
            return this.http.post<any>(url, data).pipe(map((obj) => obj || []));
    }

    onSaveGrammarQuestion(data: GrammarCreate, id: string) {
        let url = this.baseUrl;
        url += id ? `grammar/${id}/update` : `grammar/create`;

        if (id)
            return this.http.put<any>(url, data).pipe(map((obj) => obj || []));
        else
            return this.http.post<any>(url, data).pipe(map((obj) => obj || []));
    }

    onSaveLiveCreate(data: LiveClass, id: string) {
        let url = this.baseUrl;
        url += id ? `liveclass/${id}/update` : `liveclass/create`;

        if (id)
            return this.http.put<any>(url, data).pipe(map((obj) => obj || []));
        else
            return this.http.post<any>(url, data).pipe(map((obj) => obj || []));
    }

    onEvaluateVocab(data: any) {
        let url = this.baseUrl;
        url += `vocab/${data.questionType}/${data.questionId}/evaluate`;
        return this.http.post<any>(url, data).pipe(map((obj) => obj || []));
    }
    /************************************************
    *************  User ************************
    *************************************************/
    onSaveUser(obj: User, userId: string) {
        let url = this.baseUrl;
        url += userId ? `users/${userId}` : `users/signup`;

        var formData: any = new FormData();
        for (var key in obj) {
            const value = obj[key];

            formData.append(key, value);
        }
        if (userId)
            return this.http.put(url, formData)
        else
            return this.http.post(url, formData)
    }

    goBackPrev() {
        this._loc.back();
    }


    // note
    getNotesByuId(uId: String) {
        return this.http.get<any>(this.baseUrl + "user-notes/" + uId).pipe(map((obj) => obj || []));
    }

    createNote(note, userId) {
        return this.http.post<any>(this.baseUrl + "user-notes/" + userId, note).pipe(map((obj) => obj || {}));
    }

    updateNote(note, userId) {
        return this.http.put<any>(this.baseUrl + "user-note/" + userId, note).pipe(map((obj) => obj || {}));
    }

    deleteNote(id) {
        return this.http
            .delete<any>(this.baseUrl + "user-note/" + id)
            .pipe(map((obj) => obj || {}));
    }


    onPricing(data) {
        return this.http.post<any>(this.baseUrl + "stripe/create-checkout-session", data).pipe(map((obj) => obj || {}));
    }


}